export const percent = (v) => v ? `${Math.round(v * 100)}%` : "";
export const rub = (v) => v && isFinite(v) ? `${Math.round(v).toLocaleString("ru")}₽` : "";
export const number = (v) => v ? `${Math.round(v) || 0}` : "";

export const sum = (arr) => arr.reduce((acc, num) => acc + num, 0);
export const ruDate = (v) => v ? new Date(v).toLocaleDateString("ru") : "";
export const unique = (a) => [...new Set(a)];




